import HookUseNotificationManager from './fake-component.js'
import {useNotificationManager} from './hook-use-notification-manager.js'

export {useNotificationManager}
export default HookUseNotificationManager
